import { ArchBaseService } from "@/common/api.service";
import {
  CREATE_OFFER,
  DELETE_OFFER,
  GET_OFFER_DETAILS,
  GET_OFFERS_LIST,
  UPDATE_OFFER,
} from "./actions.type";
import { ISLOADING, SET_ERROR } from "./mutations.type";

const state = {
  errors: null,
};

const getters = {};

const actions = {
  async [GET_OFFERS_LIST](context, payload = {}) {
    ArchBaseService.init();
    context.commit(ISLOADING, true);
    try {
      return await ArchBaseService.get("offers", payload);
    } catch (error) {
      context.commit(SET_ERROR, error?.response || error);
      throw error;
    } finally {
      context.commit(ISLOADING, false);
    }
  },

  async [GET_OFFER_DETAILS](context, id) {
    ArchBaseService.init();
    context.commit(ISLOADING, true);
    try {
      return await ArchBaseService.get("offers", id);
    } catch (error) {
      context.commit(SET_ERROR, error?.response || error);
      throw error;
    } finally {
      context.commit(ISLOADING, false);
    }
  },

  async [CREATE_OFFER](context, payload) {
    ArchBaseService.init();
    context.commit(ISLOADING, true);
    try {
      return await ArchBaseService.create("offers", payload);
    } catch (error) {
      context.commit(SET_ERROR, error?.response || error);
      throw error;
    } finally {
      context.commit(ISLOADING, false);
    }
  },

  async [UPDATE_OFFER](context, payload) {
    ArchBaseService.init();
    context.commit(ISLOADING, true);
    try {
      return await ArchBaseService.put(`offers/${payload.id}`, payload.data);
    } catch (error) {
      context.commit(SET_ERROR, error?.response || error);
      throw error;
    } finally {
      context.commit(ISLOADING, false);
    }
  },

  async [DELETE_OFFER](context, id) {
    ArchBaseService.init();
    context.commit(ISLOADING, true);
    try {
      return await ArchBaseService.destroy(`offers/${id}`);
    } catch (error) {
      context.commit(SET_ERROR, error?.response || error);
      throw error;
    } finally {
      context.commit(ISLOADING, false);
    }
  },
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [ISLOADING](state, loading) {
    state.isLoading = loading;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
